import { render, staticRenderFns } from "./AnswerButtonsComponent.vue?vue&type=template&id=22badc59"
import script from "./AnswerButtonsComponent.vue?vue&type=script&lang=ts"
export * from "./AnswerButtonsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports